import { createSelector } from '@reduxjs/toolkit';

import { ECoworkingOfferType } from '../../../../packages/api-models/common/json_query';
import { selectCoworkingOfferType } from 'shared/selectors/jsonQuery/selectCoworkingOfferType';

import { WORKPLACE_TYPE_OPTIONS } from './selectWorkplaceTypeOptions';

const DEFAULT_LABEL = 'Тип места';

const WORKPLACE_VALUES: ECoworkingOfferType[] = [ECoworkingOfferType.FixedWorkSpace, ECoworkingOfferType.FreeWorkSpace];

export const selectWorkplaceTypeFilter = createSelector(selectCoworkingOfferType, coworkingOfferType => {
  const all = coworkingOfferType ?? [];
  const value = all.filter(v => WORKPLACE_VALUES.includes(v));

  let label = DEFAULT_LABEL;

  if (value.length > 0 && value.length < WORKPLACE_TYPE_OPTIONS.length) {
    const labels = value.map(v => WORKPLACE_TYPE_OPTIONS.find(o => o.value === v)?.label).filter(Boolean) as string[];

    if (labels.length > 0) {
      label = labels.join(', ');
    }
  }

  return {
    label,
    value,
    options: WORKPLACE_TYPE_OPTIONS,
  };
});
